export function commonFunc() {

    /**
     * フェードイン処理
     */
    $(window).scroll(function (){
        $('.fade').each(function(){
            var winHeight = $(window).height();
            var elemHeight = $(this).height();
            var position = $(this).offset().top;
            var scroll = $(window).scrollTop();
            const REMOVE_OFFSET = 100;
            // フェードイン
            if (scroll + winHeight > position){
                $(this).addClass('fade--in');
            }
            // フェードアウト
            if (scroll - elemHeight > position - REMOVE_OFFSET || scroll + winHeight < position + REMOVE_OFFSET){
                $(this).removeClass('fade--in');
            }
        });
    });

    $(document).ready( function(){
        $('.fade').each(function(){
            var winHeight = $(window).height();
            var position = $(this).offset().top;
            var scroll = $(window).scrollTop();
            // フェードイン
            if (scroll + winHeight > position){
                $(this).addClass('fade--in');
            }
        });
    });
}